import { InjectionToken, Provider } from "@angular/core";


export interface ToastRendererDef<PayloadType, Key> {
  component: unknown;
  kind: Key;
  mapInputs?: (payload: PayloadType) => Record<string, unknown>;
}
export interface ToastConfig<Registry extends Record<string, unknown>> {
  overlayPosition: ToastOverlayPosition;
  maxNumberOfToasts: number;
  toastDefaultDuration?: number;
  renderers: { [Key in keyof Registry]: ToastRendererDef<Registry[Key], Key> };
}
export interface ToastOverlayPosition {
  verticalPosition: TopMargin | BottomMargin;
  horizontalPosition: LeftMargin | RightMargin;
}
export type TopMargin = { alignment: typeof VIEW_PORT_MARGINS.TOP; value: string; };
export type BottomMargin = { alignment: typeof VIEW_PORT_MARGINS.BOTTOM; value: string; };
export type LeftMargin = { alignment: typeof VIEW_PORT_MARGINS.LEFT; value: string; };
export type RightMargin = { alignment: typeof VIEW_PORT_MARGINS.RIGHT; value: string; };
// eslint-disable-next-line @tseslint/typedef
export const VIEW_PORT_MARGINS = {
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right"
} as const;
// eslint-disable-next-line @tseslint/no-explicit-any
export const TOAST_INJECTION_TOKEN: InjectionToken<ToastConfig<any>> = new InjectionToken<ToastConfig<any>>("TOAST_INJECTION_TOKEN");
export function provideToastConfig<Registry extends Record<string, unknown>> (
  config: Readonly<ToastConfig<Registry>>
): Provider {
  return {
    provide: TOAST_INJECTION_TOKEN,
    useValue: config
  };
}
export function defineToastConfig<Registry extends Record<string, unknown>> (config: ToastConfig<Registry>): ToastConfig<Registry> {
  return config;
}
